import React from 'react'; // React is no longer explicitly needed here, but good practice to keep
import Button from 'react-bootstrap/Button'; // Not needed in the Toast component itself, but shown in original
import Col from 'react-bootstrap/Col';     // Not needed in the Toast component itself, but shown in original
import Row from 'react-bootstrap/Row';     // Not needed in the Toast component itself, but shown in original
import Toast from 'react-bootstrap/Toast';

function ToastComponent({ title, subtitle, content, show, setShow }) {
    return (
        <div
            style={{
                position: 'fixed',
                bottom: 20,
                left: 20,
                zIndex: 1050, // Ensure it's above other elements like modals
            }}
        >
            <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide>
                <Toast.Header>
                    {/* You might want to replace the placeholder image */}
                    {/* <img
                        src="holder.js/20x20?text=%20"
                        className="rounded me-2"
                        alt=""
                    /> */}
                    <strong className="me-auto">{title}</strong>
                </Toast.Header>
                <Toast.Body>{content}</Toast.Body>
            </Toast>
        </div>
    );
}

export default ToastComponent;